// The Panel Button's shadow root takes the page defaults ahead of the button rules. The React Button
// injects only the button rules into its caller's root, so it never restyles the caller's elements.
@import '../../stylesheets/defaults'
@import './index'
